import { theme } from '@m/alchemy-ui/theme';

export const accessibleChartTheme = {
  ...theme,
  colorSchemes: {
    ...theme.colorSchemes,
    alchemyLight: {
      ...theme.colorSchemes.alchemyLight,
      structural: {
        ...theme.colorSchemes.alchemyLight.structural,
        line: '#3a3a3a'
      }
    }
  }
};

export const accessibleSeriesLineColors = ['#f2330d', '#947d38', '#5961C7', '#2e9e8b', '#197fe6', '#8c59c0'];

export const getChartScrollWidth = (windowWidth: number, { offset = 150, minWidth = 320, maxWidth = 900 } = {}) =>
  Math.min(maxWidth, Math.max(minWidth, windowWidth - offset));

export const getChartMinWidth = (dataCount: number, minWidth = 640, itemWidth = 24) =>
  Math.max(minWidth, dataCount * itemWidth);
